import React, { useEffect, useMemo, useState } from "react";

/**
 * Calculate full years between birthday and a reference date (default: now).
 */
const birthdayDate="1999-06-21";
function calculateAge(birthdayDate, ref = new Date()) {
  const b = new Date(birthdayDate); // accepts Date or parsable string (ISO recommended)
  if (Number.isNaN(b.getTime())) return null;

  let age = ref.getFullYear() - b.getFullYear();
  const m = ref.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && ref.getDate() < b.getDate())) {
    age--;
  }
  return age;
}

/**
 * Age component
 * Props:
 *  - birthday: Date | string (e.g., "1999-06-15")
 *  - locale: "en" | "el" (optional; determines default label)
 *  - withLabel: boolean (optional; adds "years old" / "ετών")
 *  - as: HTML tag to render (default "span")
 */
const Age = ({ birthday=birthdayDate, locale = "en", withLabel = false, as: Tag = "span" }) => {
  const [now, setNow] = useState(() => new Date());

  // Re-render at next midnight so age stays correct across days
  useEffect(() => {
    const nextMidnight = new Date(now);
    nextMidnight.setHours(24, 0, 0, 0);
    const ms = nextMidnight.getTime() - now.getTime();
    const t = setTimeout(() => setNow(new Date()), ms);
    return () => clearTimeout(t);
  }, [now]);

  const age = useMemo(() => calculateAge(birthday, now), [birthday, now]);

  if (age == null) return <Tag>-</Tag>;

  // Optional label (very lightweight localization)
  let label = "";
  if (withLabel) {
    label = locale.startsWith("el")
      ? (age === 1 ? " έτους" : " ετών")
      : (age === 1 ? " year old" : " years old");
  }

  return <Tag>{age}{label}</Tag>;
};

export default Age;
export { calculateAge };
